export { cn } from "cnfast"
